/**
 * ChapterContent.js — Table of Contents (OHSE Content)
 * Lists all chapters in the OHSE Management Plan.
 *
 * Props:
 *   companyName  {string}  from companyInfo.name
 */

const CHAPTERS = [
  { code: 'Cover', title: 'Cover Page' },
  { code: '001', title: 'Document Control' },
  { code: '002', title: 'Project Details & Introduction' },
  { code: '003', title: 'OHSE & Environment Policy' },
  { code: '004', title: 'Hazard Identification, Risk Assessment & Control' },
  { code: '005', title: 'Hazard Categories' },
  { code: '006', title: 'Risk Matrix' },
  { code: '007', title: 'Safe Work Method Statement' },
  { code: '008', title: 'Objectives & Targets' },
  { code: '009', title: 'Personal Protective Equipment' },
  { code: '010', title: 'Roles & Responsibilities' },
  { code: '011', title: 'Training & Competency Register' },
  { code: '012', title: 'Consultation & Communication' },
  { code: '013', title: 'Toolbox Talks / Pre-Start Briefings' },
  { code: '014', title: 'Workplace Inspection Checklist' },
  { code: '015', title: 'Plant & Equipment Policy' },
  { code: '016', title: 'Plant & Equipment Register' },
  { code: '017', title: 'Plant & Equipment Pre-Start Checklist' },
  { code: '018', title: 'Plant & Equipment Regular Checklist' },
  { code: '019', title: 'Hazardous Substances / Dangerous Goods Policy' },
  { code: '020', title: 'Hazardous Substance Register' },
  { code: '021', title: 'Electrical Equipment Policy' },
  { code: '022', title: 'Electrical Equipment Register' },
  { code: '023', title: 'Hazard Reporting' },
  { code: '024', title: 'Hazard Report Form' },
  { code: '025', title: 'Incident & Injury Investigation Policy' },
  { code: '026', title: 'Register of Injuries' },
  { code: '027', title: 'Incident Investigation Report' },
  { code: '028', title: 'OHSE Management Plan Checklist' },
  { code: '029', title: 'Injury Management & Return to Work' },
  { code: '030', title: 'Daily Sign In / Sign Out' },
  { code: '031', title: 'Site Rules & Emergency Contacts' },
];

export default function ChapterContent({ companyName = '' }) {
  const cn = companyName || '[Company Name]';

  return (
    <div className="space-y-6">
      <div>
        <p className="text-xs font-semibold text-[#c9a84c] uppercase tracking-widest mb-1">Contents</p>
        <h2 className="text-xl font-bold text-[#1a1a2e] uppercase tracking-wide">Table of Contents</h2>
      </div>

      <div className="p-4 bg-[#f8f7f4] rounded-lg border border-[#e0dbd0] text-sm text-[#1a1a2e] leading-relaxed">
        <span className="font-semibold text-[#c9a84c]">{cn}</span> OHSE Management Plan comprises the following sections.
      </div>

      {/* Chapter Listing */}
      <div className="bg-white border border-[#e0dbd0] rounded-lg overflow-hidden">
        <table className="w-full text-sm border-collapse">
          <thead>
            <tr className="border-b-2 border-[#1a1a2e] bg-[#f0ede6]">
              <th className="text-left py-2.5 px-4 font-semibold text-[#1a1a2e] w-24">Section</th>
              <th className="text-left py-2.5 px-4 font-semibold text-[#1a1a2e]">Title</th>
            </tr>
          </thead>
          <tbody>
            {CHAPTERS.map((ch, idx) => (
              <tr key={ch.code} className={idx % 2 === 0 ? 'bg-white' : 'bg-[#faf9f6]'}>
                <td className="py-2 px-4 text-[#c9a84c] font-mono font-semibold text-xs">
                  {ch.code === 'Cover' ? '—' : `OHSE ${ch.code}`}
                </td>
                <td className="py-2 px-4 text-[#1a1a2e]">{ch.title}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
